export { default } from "./RecoveryNotice";
export { default as RecoveryNotice } from "./RecoveryNotice";
